import client from '../client';
import {
  BASE_ENDPOINTS,
  RESOURCES,
  SERVICES,
  VERSIONS
} from '../common/constants';

// Define the base endpoint for terrestrial evaluation
const TERRAIN_EVALUATE_BASE = BASE_ENDPOINTS.createEndpoint(
  SERVICES.TERRAIN, // Assuming 'terrain' is the service name
  VERSIONS.V1,
  RESOURCES.EVALUATE, // Resource name for terrestrial evaluation
  false // No tenant ID in the base URL
);
const TERRAIN_MONITOR_BASE = BASE_ENDPOINTS.createEndpoint(
  SERVICES.TERRAIN, // Assuming 'terrain' is the service name
  VERSIONS.V1,
  'monitor', // Resource name for terrestrial evaluation
  false // No tenant ID in the base URL
);

const TERRAIN_MONITOR_BASE_V2 = BASE_ENDPOINTS.createEndpoint(
  SERVICES.TERRAIN, // Assuming 'terrain' is the service name
  VERSIONS.V2,
  'monitor', // Resource name for terrestrial evaluation
  false // No tenant ID in the base URL
);

const TERRAIN_farmreport_BASE_V2 = BASE_ENDPOINTS.createEndpoint(
  SERVICES.TERRAIN, // Assuming 'terrain' is the service name
  VERSIONS.V2,
  'farmreport', // Resource name for terrestrial evaluation
  false // No tenant ID in the base URL
);

const TERRAIN_farmland_BASE_V2 = BASE_ENDPOINTS.createEndpoint(
  SERVICES.TERRAIN, // Assuming 'terrain' is the service name
  VERSIONS.V2,
  'farmland', // Resource name for terrestrial evaluation
  false // No tenant ID in the base URL
);

const TERRAIN_compare_BASE = BASE_ENDPOINTS.createEndpoint(
  SERVICES.TERRAIN, // Assuming 'terrain' is the service name
  VERSIONS.V1,
  'compare', // Resource name for terrestrial evaluation
  false // No tenant ID in the base URL
);

export const getTerrestrialEvaluation = cluster =>
  client.get(`${TERRAIN_EVALUATE_BASE}/${cluster}/`);

export const getOverallEvaluation = cluster =>
  client.get(`${TERRAIN_EVALUATE_BASE}/overall/${cluster}/`);

export const getOverallMonitoring = cluster =>
  client.get(`${TERRAIN_MONITOR_BASE_V2}/overall/${cluster}/`);

export const getTerrestrialMonitoring = cluster =>
  client.get(`${TERRAIN_MONITOR_BASE_V2}/${cluster}/`);

export const getMonitoringLocations = tenant =>
  client.get(`${TERRAIN_MONITOR_BASE}/locations/`, {
    params: {
      tenant_id: tenant
    }
  });

export const getLocations = tenant =>
  client.get(`${TERRAIN_EVALUATE_BASE}/locations/`, {
    params: {
      tenant_id: tenant
    }
  });

export const getExportAllData = tenant_id =>
  client.get(`${TERRAIN_farmreport_BASE_V2}/export/table`);

export const getTerrainData = ({ tenant_id, parent_id, project_ids }) =>
  client.post(`${TERRAIN_farmland_BASE_V2}/`, {
    tenant_id: tenant_id,
    parent_id: parent_id,
    project_ids: project_ids
  });

export const getFarmTableData = ({ cursor, limit, tenant, filter }) =>
  client.post(`${TERRAIN_farmreport_BASE_V2}/table/`, {
    tenant_id: tenant,
    cursor: cursor,
    limit: limit,
    filters: filter
  });

export const getTerrestrialComparison = data =>
  client.post(`${TERRAIN_compare_BASE}/`, data);

export const getComparisonLocations = tenant =>
  client.get(`${TERRAIN_MONITOR_BASE}/locations/`, {
    params: {
      tenant_id: tenant
    }
  });
